/**
 * Labstep
 *
 * @module components/Protocol/Action/Create
 * @desc Create Action for protocol
 */

import EntityActionCreate from 'labstep-web/components/Entity/Action/Create';
import type React from 'react';
import type { IProtocolActionCreateProps } from './types';

export const ProtocolActionCreate: React.FC<
  IProtocolActionCreateProps
> = ({ body = {}, options, ...rest }) => (
  <EntityActionCreate
    entityName="protocol"
    body={body}
    options={options}
    {...rest}
  />
);
